/**
 * @module Item
 */

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LabelsClass } from '@class/labels.class';
import { RightsClass } from '@class/right.class';
import { LinkableType } from '@models/links.model';
import { UID } from '@models/uid.model';
import { UserClass } from '@class/user.class';
import { Subscription } from 'rxjs';
import { LanguageType } from '@models/language.model';
import { AuthService } from '@services/auth/auth.service';
import { TagsClass } from '@class/tag.class';
import { UidClass } from '@class/uid.class';
import { ItemRole } from '@functions/item.functions';

@Component({
  selector: 'app-item-strip',
  templateUrl: './item-strip.component.html',
  styleUrls: ['./item-strip.component.css']
})
export class ItemStripComponent implements OnInit, OnDestroy {

  @Input() labels: LabelsClass;
  @Input() tags: TagsClass;
  @Input() label: string; //à utiliser à la place de 'labels' si pas de traduction nécéssaire
  @Input() rights: RightsClass;
  @Input() type: LinkableType;
  @Input() uid: UidClass;
  @Input() isModified: boolean;
  @Input() isInfo: boolean;
  @Input() showInfoAndBookmark: boolean = false;
  @Input() icon: string; //style+symbol
  @Input() color: string; //name or hexa
  @Input() url: string; //à utiliser à la place de 'icon' pour afficher une image à la place
  @Input() isDisplayable: boolean = false;
  @Input() isStudio: boolean = false;
  @Input() isSlides: boolean = false;

  @Output() sendEdit: EventEmitter<UID>;
  @Output() sendDisplay: EventEmitter<UID>;
  @Output() sendInfo: EventEmitter<UID>;
  @Output() sendStudio: EventEmitter<UID>;
  @Output() sendSlides: EventEmitter<UID>;

  user: UserClass;
  user$sub: Subscription;
  language: LanguageType;
  language$sub: Subscription;
  isBookmark: boolean;
  hasRole: boolean;
  
  constructor(
    private $auth: AuthService
  ) {
    this.sendEdit = new EventEmitter<UID>();
    this.sendDisplay = new EventEmitter<UID>();
    this.sendInfo = new EventEmitter<UID>();
    this.sendStudio = new EventEmitter<UID>();
    this.sendSlides = new EventEmitter<UID>();

    this.language$sub = this.$auth.language$.subscribe({
      next: (language: LanguageType) => {
        this.language = language;
      }
    }); 
  }

  ngOnInit() {
    this.user$sub = this.$auth.user$.subscribe({
      next: (user: UserClass) => {
        this.user = user;
        this.isBookmark = this.user.bookmarks.has(this.type, this.uid.value);
        this.hasRole = this.user.roles.has(ItemRole(this.type));
      }
    });
  }

  ngOnDestroy() {
    this.user$sub.unsubscribe();
    this.language$sub.unsubscribe();
  }

  onEdit() {
    this.sendEdit.emit(this.uid.value);
  }

  onStudio() {
    this.sendStudio.emit(this.uid.value);
  }

  onSlides() {
    this.sendSlides.emit(this.uid.value);
  }

  onDisplay() {
    this.sendDisplay.emit(this.uid.value);
  }

  onBookmark() {
    if(this.isBookmark) this.user.bookmarks.remove(this.type, this.uid.value);
    else this.user.bookmarks.add(this.type, this.uid.value);
    this.isBookmark = this.user.bookmarks.has(this.type, this.uid.value);
    this.$auth.updateBookmarks({ bookmarks: this.user.model.bookmarks });
  }

  onInformations() {
    this.sendInfo.emit(this.uid.value);
  }

}
